import type { RecommendationResult } from '../types'

interface AnalysisCardProps {
  readonly recommendation: RecommendationResult['recommendations'][0]
}

/**
 * The per-gif reasoning/strengths/limitations detail. Good content, but demoted:
 * rendered inside a collapsed disclosure on the card rather than shown by
 * default. No rank — stances made per-gif ranking meaningless.
 */
export const AnalysisCard = ({ recommendation }: AnalysisCardProps) => {
  return (
    <div className="space-y-3">
      {/* AI Reasoning */}
      {recommendation.reasoning && (
        <div>
          <p className="text-sm text-default-700">{recommendation.reasoning}</p>
        </div>
      )}

      {/* Strengths and Limitations in a more compact layout */}
      {((recommendation.strengths && recommendation.strengths.length > 0) ||
        (recommendation.limitations &&
          recommendation.limitations.length > 0)) && (
        <div className="space-y-3">
          {/* Strengths */}
          {recommendation.strengths && recommendation.strengths.length > 0 && (
            <div>
              <h4 className="text-sm font-semibold mb-2">Strengths</h4>
              <div className="flex flex-wrap gap-1">
                {recommendation.strengths.map((strength, index) => (
                  <span
                    key={index}
                    className="inline-block px-2 py-1 bg-success/20 text-success-600 rounded-xl text-xs break-words"
                  >
                    {strength}
                  </span>
                ))}
              </div>
            </div>
          )}

          {/* Limitations */}
          {recommendation.limitations &&
            recommendation.limitations.length > 0 && (
              <div>
                <h4 className="text-sm font-semibold mb-2">Limitations</h4>
                <div className="flex flex-wrap gap-1">
                  {recommendation.limitations.map((limitation, index) => (
                    <span
                      key={index}
                      className="inline-block px-2 py-1 bg-warning/20 text-warning-600 rounded-xl text-xs break-words"
                    >
                      {limitation}
                    </span>
                  ))}
                </div>
              </div>
            )}
        </div>
      )}
    </div>
  )
}
